import { render, staticRenderFns } from "./statistiche.vue?vue&type=template&id=6e1a3d0a&"
import script from "./statistiche.vue?vue&type=script&lang=js&"
export * from "./statistiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports